import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/previous-result/", label: "Previous Result" },
  { to: "/common-number/", label: "Common Number" },
  { to: "/juwai-teer-guide/", label: "Guide" },
  { to: "/about/", label: "About" },
  { to: "/contact/", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-white/85 border-b border-[hsl(var(--border))]" data-testid="site-header">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
            <Logo size={44} />
            <div className="leading-tight">
              <div className="font-display text-[22px] font-extrabold tracking-tight text-[color:var(--brand-purple-deep)]">
                JUWAI TEER
              </div>
              <div className="text-[11px] sm:text-xs text-[color:var(--brand-purple)]/80">
                Official Juwai Teer Result
              </div>
            </div>
          </Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="p-2 rounded-lg hover:bg-[color:var(--brand-purple-soft)]"
            aria-label="Toggle menu"
            data-testid="menu-toggle-button"
          >
            {open ? <X className="text-[color:var(--brand-purple-deep)]" /> : <Menu className="text-[color:var(--brand-purple-deep)]" />}
          </button>
        </div>
        {open && (
          <nav className="pb-4" data-testid="mobile-nav">
            <ul className="grid grid-cols-2 gap-2">
              {NAV.map((n) => (
                <li key={n.to}>
                  <NavLink
                    to={n.to}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-lg text-sm font-semibold ${isActive ? "bg-[color:var(--brand-purple)] text-white" : "text-[color:var(--brand-purple-deep)] hover:bg-[color:var(--brand-purple-soft)]"}`
                    }
                    data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {n.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
      <div className="border-t border-[hsl(var(--border))] bg-[color:var(--brand-purple-soft)]/40">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-3 text-xs sm:text-sm">
          <span className="inline-flex items-center gap-2 font-bold text-[color:var(--brand-purple-deep)]">
            <span className="live-dot" /> LIVE UPDATE
          </span>
          <span className="hidden sm:inline text-[color:var(--brand-purple)]">·</span>
          <span className="text-[color:var(--brand-purple)] flex-1 truncate">
            Get fast &amp; accurate Juwai Teer results
          </span>
          <span className="hidden sm:inline text-xs text-[color:var(--brand-purple)]/70">Updated Just Now</span>
        </div>
      </div>
    </header>
  );
}
